import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {Department} from '@app/core/models/department.model';
import {User} from '@app/core/models/user.model';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

export interface IGetDepartmentMembersAndPunchStatusResponse {
	department: Department;
	users: User[];
}

@Injectable()
export class PunchUserService extends BaseService {
	public redirectToLoginErrors: string[] = ['Invalid scope(s) provided.', 'invalidDatabase'];

	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		private router: Router,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public getDepartmentsForTenant(): Observable<Department[]> {
		return this.httpService.getJson<Department[]>('auth/punchUser/departments', {page_size: 200}).pipe(
			map((res: any) => {
				if (res.error && this.redirectToLoginErrors.indexOf(res.error) !== -1) {
					this.router.navigate(['/punch-login']);
					return;
				}

				return res.data.map(department => new Department(this.tenantTZ, this.interService).deserialize(department));
			})
		);
	}
}
